module.exports = __webpack_public_path__ + "img/avvera-2023.950766e3.jpg";